import { Dialog, Select, Checkbox } from "@vitalsource/vstui";
import React from "react";
import Slider from "./slider";
import { throttle } from "throttle-debounce";
import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import { Dispatcher } from "../../gadgets/flux";

const Note = styled.div`
  font-style: italic;
  font-size: 1.2rem;
  margin-top: -10px;
`;

const CheckboxContainer = styled.div`
  margin: 24px 0;
`;

const Description = styled.div`
  border-top: 1px solid ${cloud.getShade(4)};
  font-size: 1.2rem;
  padding-top: 5px;
  a {
    font-size: 1.2rem;
    color: ${props => props.theme.vstui.color.primary.getShade(6)};
    text-decoration: underline;
  }
  p {
    margin: 0;
    &:not(:last-child) {
      margin-bottom: 6px;
    }
  }
`;

export default class TtsSettingsDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speedValue: props.currentRate
    };
    this.jigsawRateChange = throttle(500, this.jigsawRateChange);
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps.isOpen && !this.props.isOpen) {
      this.setState({
        speedValue: nextProps.currentRate
      });
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.props.isOpen && !prevProps.isOpen) {
      Dispatcher.emit(Dispatcher.MODAL_OPEN);
    }
  }

  updateSpeedValues = e => {
    // We are tracking speed separately from jigsaw's speed to keep the slider snappy
    this.setState({
      speedValue: e.currentTarget.value
    });
    this.jigsawRateChange(e.currentTarget.value);
  };

  jigsawRateChange = value => {
    this.props.changeRate(value);
  };

  updateVoice = e => {
    this.props.setVoice(e.currentTarget.value);
  };

  toggleAltText = () => {
    const { disableAltText, enableAltText, altEnabled } = this.props;

    if (altEnabled) {
      disableAltText();
    } else {
      enableAltText();
    }
  };

  render() {
    let { isOpen, onRequestClose } = this.props;
    return (
      <Dialog
        open={isOpen}
        title={i18n.t("tts.read-aloud-settings")}
        size="medium"
        onRequestClose={onRequestClose}
        rootSelector="#bookshelf"
        darkHeader
      >
        <Slider
          onChange={this.updateSpeedValues}
          value={this.state.speedValue}
        />
        <Select
          label={i18n.t("tts.change-voice")}
          onChange={this.updateVoice}
          value={this.props.currentVoice}
          fullWidth
        >
          {this.props.voices.map((voice, index) => (
            <option key={voice.name} value={index}>
              {voice.name} ({voice.lang})
            </option>
          ))}
        </Select>
        <Note>{i18n.t("tts.language-note")}</Note>
        <CheckboxContainer>
          <Checkbox
            label={i18n.t("tts.alt-text")}
            onChange={this.toggleAltText}
            checked={this.props.altEnabled}
          />
        </CheckboxContainer>
        <Description>
          <p>{i18n.t("tts.description-1")}</p>
          <p
            dangerouslySetInnerHTML={{
              __html: i18n.t("tts.description-2", {
                url: i18n.t("locations.zendesk-accessibility")
              })
            }}
          />
        </Description>
      </Dialog>
    );
  }
}

TtsSettingsDialog.defaultProps = {
  voices: []
};
